import React, { lazy, Suspense } from 'react';
import { Navigate, useRoutes, Outlet } from 'react-router-dom';
import { KeepAlive } from 'react-activation';

import { mainRoutes, HomePage } from './main';
import FinancialSaldo from '../../sections/financial/financial-saldo';
import FinancialAlerts from '../../sections/financial/financial-alerts';
import FinancialDetails from '../../sections/financial/financial-details';
import DashboardLayout from '../../layout/layout';
import FinancialConsumingAnalitics from '../../sections/financial/financial-consuming-analitics';
import FinancialIncomeExpenses from '../../sections/financial/financial-income-expenses';
import FInancialConductProfile from '../../sections/financial/financial-conduct-profile';
import FinancialCreditProfile from '../../sections/financial/financial-credit-profile';
import LoginPage from '../../pages/auth/login';
import AuthClassicLayout from '../../auth/auth/classic';
import FinancialDragNDrop from '../../sections/financial/financial-dragndrop';
import RegisterPage from '../../pages/auth/register';
import { RoleBasedGuard } from '../../auth/guard';
import { AuthConsumer } from '../../auth/context';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <AuthClassicLayout>
          <LoginPage />
        </AuthClassicLayout>
      ),
    },

    {
      path: '/register',
      element: (
        <AuthClassicLayout>
          <RegisterPage />
        </AuthClassicLayout>
      ),
    },
     
    {
      path: 'financial',
      element: (
        <Suspense>
          <AuthConsumer>
            <Outlet />
          </AuthConsumer>
        </Suspense>
      ),
      children: [
        {
          path: '',
          index: true,
          element: (
            <DashboardLayout>
              <FinancialDragNDrop />
            </DashboardLayout>
          ),
        },
        {
          path: 'flow',
          index: true,
          element: (
            <DashboardLayout>
              <FinancialIncomeExpenses />
            </DashboardLayout>
          ),
        },
        {
          path: 'balance',
          index: true,
          element: (
              <DashboardLayout>
                <FinancialSaldo />
              </DashboardLayout>
          ),
        },
        {
          path: 'insights',
          index: true,
          element: (
            <DashboardLayout>
              <FinancialAlerts />
            </DashboardLayout>
          ),
        },
        {
          path: 'profile',
          index: true,
          element: (
            <DashboardLayout>
              <FInancialConductProfile />
            </DashboardLayout>
          ),
        },
        {
          path: 'details',
          index: true,
          element: (
              <RoleBasedGuard roles={['admin']} hasContent>
                <DashboardLayout>
                  <FinancialDetails />
                </DashboardLayout>
              </RoleBasedGuard>
          ),
        },
        {
          path: 'consuming-analitics',
          index: true,
          element: (
            <DashboardLayout>
              <FinancialConsumingAnalitics />
            </DashboardLayout>
          ),
        },
        {
          path: 'credit-profile',
          index: true,
          element: (
            <DashboardLayout>
              <FinancialCreditProfile />
            </DashboardLayout>
          ),
        },
      ]
    },

    // Main routes
    ...mainRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
